import { useState } from "react";
import { ReactComponent as TripleDot } from "../../assets/General/triple-dot.svg";
import { ArrowPopper } from "../ArrowPopper/ArrowPopper";
import s from "./TripleDotPoperMenu.module.css";

type TripleDotPoperMenuProps = {
  menuItemDta?: {
    title: string;
    action: () => void;
    disabled?: boolean;
    styles?: React.CSSProperties;
  }[];
  menuItemData?: {
    title: string;
    action: () => void;
    disabled?: boolean;
    styles?: React.CSSProperties;
  }[];
};

const TripleDotPoperMenu = ({
  menuItemDta,
  menuItemData,
}: TripleDotPoperMenuProps) => {
  const [open, setOpen] = useState(false);
  const items = menuItemDta || menuItemData || [];

  return (
    <ArrowPopper
      trigger={
        <div role="button" className={s.triggerBtn}>
          <TripleDot />
        </div>
      }
      padding="0px"
      maxWidth="380px"
      open={open}
      setOpen={setOpen}
    >
      <div className={s.menuContent}>
        {items.map((item, index) => (
          <div
            className={s.menuItem}
            style={{
              ...{ opacity: item.disabled ? 0.5 : 1 },
              ...item.styles,
            }}
            onClick={() => {
              if (item.disabled) return;
              item.action();
              setOpen(false);
            }}
            key={index}
          >
            {item.title}
          </div>
        ))}
      </div>
    </ArrowPopper>
  );
};

export default TripleDotPoperMenu;
